<template>
  <div class="relative">
    <section aria-label="footer"
      class="sticky md:sticky inset-x-0 bottom-0 h-auto w-full text-center bg-b2c-grey-300 font-sans-serif text-b2c-grey-100">
      <section class="md:flex md:flex-row">
        <section :aria-label="$t('footer.logos')"
          class="flex sm:flex-row md:flex-col justify-center py-6  md:w-1/3"
          :class="isGermany ? 'pl-3' : 'md:pl-24'">
            <white-salvi-logo class="pr-3 pt-2 md:py-6" />
            <white-lyon-logo />
        </section>
        <section class="w-full">
          <div class="md:flex md:flex-col md:text-xs lg:text-base">
            <div class="md:flex md:flex-row md:w-full md:justify-between md:text-left">
              <nav class="flex flex-col md:justify-center md:pt-10 md:pl-6 md:h-32"
              :class="isGermany ? 'md:w-full' : 'md:w-1/2'">
                <router-link class="p-1" :class="fontHairline()"
                             :to="{ name: 'TermsAndConditions' }">
                  {{ $t("footer.terms") }}
                </router-link>
                <router-link class="p-1" :class="fontHairline()"
                             :to="{ name: 'ShippingAndPayments' }">
                  {{ $t("footer.shipping") }}
                </router-link>
                <router-link class="p-1" :class="fontHairline()"
                             :to="{ name: 'ReturnAndRefund' }">
                  {{ $t("product.returns") }}
                </router-link>
                <router-link class="p-1" :class="fontHairline()"
                            :to="{ name: 'Imprint' }">
                {{ $t("footer.imprint") }}
              </router-link>
              </nav>
              <nav class="flex flex-col mb:pb-0 md:justify-start md:pt-9 md:pl-0 lg:pl-20 md:h-32"
              :class="isGermany ? 'md:w-full pb-2' : 'md:w-1/3'">
                <router-link class="p-1" :class="fontHairline()" :to="{ name: 'About' }">{{ $t("footer.about")
                  }}
                </router-link>
                <a :href="shop.website" class="p-1" :class="fontHairline()">
                  {{ $t("footer.shop") }}
                </a>
                <router-link to="/contact" class="p-1" :class="fontHairline()">
                  {{ $t("footer.contact") }}
                </router-link>
                <a :href="shop.facebook" aria-label="Facebook"
                class="hidden md:flex justify-start px-2 h-24" v-if="isGermany">
                  <facebook-logo />
                </a>
              </nav>
              <a :href="shop.facebook" aria-label="Facebook"
                class="hidden md:flex justify-start w-1/4 items-center px-2" v-if="!isGermany">
                  <facebook-logo />
              </a>
              <section :aria-label="$t('footer.paymentLogos')"
                class="md:hidden flex flex-row justify-between px-4 items-center border-t border-b shadow-inner">
                  <paypal-logo aria-label="Paypal Logo" v-if="paymentIsAvailable('paypal')" />
                  <mastercard-logo aria-label="Mastercard Logo" v-if="paymentIsAvailable('stripe')" />
                  <amex-logo class="pr-2" aria-label="American Express Logo" v-if="paymentIsAvailable('stripe')" />
                  <visa-logo class="pr-1" aria-label="Visa Logo" v-if="paymentIsAvailable('stripe')" />
                  <img src="/sepa.png" alt="Sepa Direct Debit Logo" class="w-12 px-1" v-if="paymentIsAvailable('sepa')" >
                  <sofort-logo class="pl-1" aria-label="Sofort Banking Logo" v-if="paymentIsAvailable('sofort')" />
              </section>
            </div>
            <div class="md:flex md:flex-row md:pt-6 md:pl-6 w-full">
              <section class="md:border-t md:border-gray-300 md:w-1/2 sm:text-center md:text-left w-3/4 mx-auto"
                :aria-label="$t('footer.newsletterTitle')" v-if="isGermany">
                <newsletter />
              </section>
              <section class="hidden md:flex flex-col justify-start border-t " :class="isGermany ? 'md:w-1/2': 'w-4/5'">
                <div class="flex flex-row text-left pt-3">
                  <lock-icon></lock-icon>
                  <p class="text-sm pl-2 font-serif uppercase">{{ $t("product.payment") }}</p>
                </div>
                <div :aria-label="$t('footer.paymentLogos')" class="flex justify-between items-center pr-4">
                    <paypal-logo aria-label="Paypal Logo" v-if="paymentIsAvailable('paypal')" />
                    <mastercard-logo aria-label="Mastercard Logo" v-if="paymentIsAvailable('stripe')" />
                    <amex-logo class="pr-2" aria-label="American Express Logo" v-if="paymentIsAvailable('stripe')" />
                    <visa-logo class="pr-1" aria-label="Visa Logo" v-if="paymentIsAvailable('stripe')" />
                    <img src="/sepa.png" alt="Sepa Direct Debit Logo" class="w-12 px-1" v-if="paymentIsAvailable('sepa')" >
                    <sofort-logo class="pl-1" aria-label="Sofort Banking Logo" v-if="paymentIsAvailable('sofort')" />
                </div>
                <div class="font-serif text-left pt-3" :class="isGermany ? '' : 'pb-5'">
                  <p class="uppercase text-md pb-2">{{ $t("footer.customer-service") }}</p>
                  <div class="flex items-center">
                    <a class="hover:text-b2c-grey-150 pr-8" :href="'mailto:'+shop.email">{{ shop.email }}</a>
                    <p v-if="shop.phone"> {{ shop.phone }} </p>
                  </div>
                </div>
              </section>
              <section class="flex flex-col text-center md:text-left border-t md:hidden">
                <div class="font-sans-serif pt-3 text-sm" :class="isGermany ? '' : 'pb-5'">
                  <p class="uppercase pb-2 text-md">{{ $t("footer.customer-service") }}</p>
                  <a class="hover:text-b2c-grey-150" :href="'mailto:'+shop.email">{{ shop.email }}</a>
                  <p v-if="shop.phone"> {{ shop.phone }} </p>
                </div>
              </section>
            </div>
          </div>
        </section>
      </section>
      <section class="h-auto w-full text-center bg-b2c-grey-600 text-b2c-grey-200">
        <nav class="md:hidden flex flex-row justify-center items-center w-full py-2">
          <a :href="shop.facebook"
          aria-label="Facebook">
            <facebook-logo />
          </a>
        </nav>
        <div class="items-center flex flex-col md:pt-2 md:justify-between md:items-center">
          <div class="text-xs md:px-2">
            BeToSee is another fine product of
            <a href="https://www.thenonsensefactory.it">The Nonsense Factory</a>
          </div>
          <h4 class="text-xs md:px-2">Graphic design by <a
            href="https://www.ivanbarra.it/">Ivan Barra</a></h4>
          <div class="text-xs md:pl-2">{{new Date().getFullYear()}} © Salvi Music</div>
          <div class="flex flex-row justify-center md:justify-between px-16 text-xs pb-2 md:p-2">
            <button @click="openCookiePolicy">
              {{ $t("footer.cookie") }}
            </button>
          </div>
        </div>
      </section>
    </section>
  </div>
</template>

<script>
import WhiteSalviLogo from '@/components/graphics/WhiteSalviLogo.vue';
import WhiteLyonLogo from '@/components/graphics/WhiteLyonLogo.vue';
import FacebookLogo from '@/components/graphics/FacebookLogo.vue';
import PaypalLogo from '@/components/graphics/PaypalLogo.vue';
import MastercardLogo from '@/components/graphics/MastercardLogo.vue';
import VisaLogo from '@/components/graphics/VisaLogo.vue';
import AmexLogo from '@/components/graphics/AmexLogo.vue';
import LockIcon from '@/components/graphics/LockIcon.vue';
import axios from 'axios';
import { mapGetters } from 'vuex';
import { getAvailablePayments } from '@/services/CartService';
import Newsletter from './Newsletter.vue';
import SofortLogo from './SofortLogo.vue';

export default {

  components: {
    WhiteSalviLogo,
    WhiteLyonLogo,
    FacebookLogo,
    PaypalLogo,
    MastercardLogo,
    VisaLogo,
    AmexLogo,
    LockIcon,
    Newsletter,
    SofortLogo,
  },

  data() {
    return {
      paymentMethods: [],
    };
  },

  computed: {
    ...mapGetters({
      isGermany: 'isGermany',
      shop: 'shop',
    }),
  },

  created() {
    this.getPaymentMethods();
  },

  methods: {
    openCookiePolicy() {
      axios.get('/api/cookie-policy')
        .then(({ data }) => {
          window.location.href = data.url;
        });
    },

    getPaymentMethods() {
      getAvailablePayments().then(({ data }) => {
        this.paymentMethods = [];
        this.paymentMethods = data;
      });
    },

    paymentIsAvailable(paymentMethod) {
      return this.paymentMethods.find((method) => method.slug === paymentMethod);
    },
  },
};
</script>
